import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { AreaMasterTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<AreaMasterTheme>;
const css = baseCss as ThemedCssFunction<AreaMasterTheme>;

export const AreaMaster = styled.div`
  width: 100%;
  height: 100%;
`;
